import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useTranslation } from 'react-i18next';
import { useStyles, useStylesHelperText } from './styles';

function InputTextOutlined({
  styles,
  type,
  placeholder,
  value,
  isError,
  isLabelInputDisplayed,
  isPlaceholderInputDisplayed,
  handleChangeInput,
  handleKeyUpInput,
  handleDisplayPlaceholderInput,
  handleDisplayLabelOrPlaceholder,
  minlength,
  maxlength,
}) {
  const { t } = useTranslation('auth');
  const classes = useStyles(isError);
  const classesHelperText = useStylesHelperText();

  return (
    <>
      <TextField
        inputProps={{ minLength: minlength, maxLength: maxlength }}
        style={styles}
        type={type}
        classes={classes}
        variant="filled"
        value={value}
        onChange={handleChangeInput}
        onKeyUp={handleKeyUpInput}
        onBlur={handleDisplayLabelOrPlaceholder}
        onFocus={handleDisplayPlaceholderInput}
        label={isLabelInputDisplayed && placeholder}
        placeholder={isPlaceholderInputDisplayed ? placeholder : ''}
      />
      {isError && (
        <FormHelperText className={classesHelperText.text}>
          {t('errorMessage')}
        </FormHelperText>
      )}
    </>
  );
}

export default InputTextOutlined;
